let catalogData = [
    {
        name: "Master Catalog",
        year: 2020,
        link: "https://e.issuu.com/anonymous-embed.html?u=fisherathleticequipment&d=2020mastercatalogforweb",
        image: "https://lh3.googleusercontent.com/BRQPOyzeEkKCEKl71oTpzdNoR-gCenr8w95ntOralnn9ZtGvsMEsY4Sh9MynsPLmm3h272gg7kBQO-rcik94ZrK_wrTgWu3IS-D3wlA8LgCdN0XpRrpAlwfA5c5djNzmx4aI8BBNFA=w233-h300-no"
    },
    {
        name: "Football Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020_new_football_catalog_with_front_n_back_covers?fr=sYmU0NzM3MDQ0Mg",
        image: "https://lh3.googleusercontent.com/wwMu8en33WYXFQsDyTyw_9WbSrc9zAyGDcGRBLKSkEFQrJyp0jUXrYJDlkHeHI7wX8Pq4Z9VE4o4XYYx65zerS2cVhh0kVXjJ0Mzjx-j3VNafC3RhDibFRj-OIOsTCya0jtUq-lR2g=w235-h300-no"
    },
    {
        name: "Baseball Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020baseball_institute_compressed?fr=sYWYyODM3MDQ0Mg",
        image: "https://lh3.googleusercontent.com/OQuOjS3Zgb7S2ouzWKo788Vd4JXkY3WmPIcqOAfeCQIfJ5Nx1yxYjrDCLTxa8b9Uo7NbHLsGgHWGojjVT34IzqBm0gxaTF_d-Oj5xHzLIFVirIbGDsdHudlL39BE3G0C6wQLty_R1A=w232-h300-no"
    },
    {
        name: "Branding Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020_facility_branding?fr=sZDBmYTM3MDQ0Mg",
        image: "https://lh3.googleusercontent.com/BD7EBUOzvdqLHRvARQHjvbqxD9s5GfDo6ONiFaV15hiukAtpsb4ivHR3MlNpRSU0FKjf9xzCuyMbWenEtP-zFMlJPLNk99maFNtOYBeupLLAT8_dssYOnGmArncq-LV5eUrnYBGp8g=w232-h300-no"
    },
    {
        name: "Chair Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020_chairs_and_stools_institute?fr=sYzA5ZDM3MDQ0Mg",
        image: "https://lh3.googleusercontent.com/bLzcsQd72fn4YGG7Tx87cH6wsS2d8EfhKRx09CW59ZfoOGAui2ideEP36a0YKMmp9NI7cTWNnHbpEDc7sfvsqXHQOPUoScWBNiOFTp5OioUOdBydrYCTe_LX3G1CVQepprV906FnLA=w232-h300-no"
    },
    {
        name: "Padding Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020_protectivepadding_ins_compressed?fr=sZmE0ODM3MDQ0Mg",
        image: "https://lh3.googleusercontent.com/H5dy8sifmauZ4OHCYb-PxtUsnjk9oc16mqGUKVO9LynKflyxqatsaVtzhcnAvdLs9_0yMLvQnZ2xwcrSJG2I4TZi67Q-LsyJpb5h-8Uvf11ABnHInU_NU1sciKnHWvUqOknqOtGrNQ=w232-h300-no"
    },
    {
        name: "Track Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020-track___field_ins_compressed?fr=sN2ZkNDM3MDQ0Mg",
        image: "https://lh3.googleusercontent.com/pgVsDgfrDlQyRg6peOdFBRLyCouayl7lyhRJvv_2Y-1FEE0zlWsGhLZewXBGwsxhNoBGh1cVlPnOjdhw-RZMUz7cjQwCQKDmmKTEmjUPrKDnV_fVhvguc97PLwL2sRabmo2W6f8deg=w232-h300-no"
    },
    {
        name: "PPE Catalog",
        year: 2020,
        link: "https://issuu.com/fisherathleticequipment/docs/2020_covid19_package_institute-no_fold-comp?fr=sYTMyNDM3MDQ0Mg",
        image: "https://firebasestorage.googleapis.com/v0/b/fisher-website-r.appspot.com/o/products%2F2020-ppe-catalog-web-sm.jpg?alt=media&token=73e3694b-9dd8-4e3e-8f7e-4e42fdf73f72"
    }
]

export default catalogData